import { withStyles } from '@material-ui/core/styles'
import React, { useState, useEffect } from 'react'
import styles from './styles'
import { useCourseSettings } from 'src/hooks/useCourseSettings'

import { useDispatch, useSelector } from 'react-redux'

import { AssignmentFieldNames } from 'src/model/assignment'

import { initialThemeSettings } from 'src/model/theme'
import themePresets from 'src/model/theme/presets'
import { ChromePicker } from 'react-color'
import URLs from 'src/api/url'
import { themeDrawerOpen } from 'src/reducers/course/action'

import {
  Alert,
  Card,
  CardActionArea,
  CardActions,
  CardMedia,
  Typography,
  Divider,
  Chip,
  Autocomplete,
  CircularProgress,
  Tooltip,
  Popover,
} from '@material-ui/core'

import SettingStretch from './components/stretch'
import SettingDirection from './components/direction'
import SettingLayout from './components/layout'

import { mediaImageUploadAction } from 'src/reducers/media-image/action'
import FontSelect from 'src/pages/workspace/branding/font-select'
import { showModal } from 'src/components/upgrade-popup'

import URL from 'src/api/url/api'
import rgbaParser from 'src/utils/rgbaParser'
import { track } from '@amplitude/analytics-browser'
import { CoreButton, CoreIconButton, CoreTextField } from 'src/components/core'
import { Icon } from '@iconify/react'
const availableSizes = [
  { label: 'XS' },
  { label: 'S' },
  { label: 'M' },
  { label: 'L' },
  { label: 'XL' },
]
const SETTING_KEY = 'theme'
const ThemeSettings = props => {
  const { page, setPage, classes } = props
  const { execute, update, exists, value } = useCourseSettings(SETTING_KEY)

  const [colors, setColors] = useState({})
  const [pageReady, setPageReady] = useState(true)
  const [anchorEl, setAnchorEl] = useState(null)
  const [showPreview, setShowPreview] = useState(false)
  const [pickerVisibles, setPickerVisibles] = useState({
    fontColor: false,
    backgroundColor: false,
    cardBackgroundColor: false,
    buttonColor: false,
  })
  const dispatch = useDispatch()

  const courseEntity = useSelector(state => state.course.course)

  const isUserPremium = true // Number(window.CONSTANTS.USER_ROLE_ID) !== 1

  const [themeSettings, setThemeSettings] = useState(
    exists && value !== false ? value : initialThemeSettings,
  )

  useEffect(() => {
    if (exists && value !== false) {
      setThemeSettings(value)
    }
  }, [value])

  const onUploadBackgroundImage = event => {
    dispatch(
      mediaImageUploadAction(event.target.files[0], '', result => {
        setThemeSettings({
          ...themeSettings,
          bodyBackgroundImage: URL.STORAGE + result.url,
        })
      }),
    )
  }

  const handleOpenPremiumDetails = () => {
    showModal(dispatch) // premium details
  }

  const saveSettings = () => {
    if (!pageReady) return
    if (!isUserPremium) return

    //setPageReady(false)

    const callback = () => {
      //deleted show preview state since drawer is closing after saving.
      if (!showPreview) {
        setTimeout(() => setShowPreview(false), 7500)
      }
    }

    if (!exists) {
      execute(themeSettings, callback)
    } else {
      update(themeSettings, callback)
    }
    dispatch(themeDrawerOpen())
  }
  const handleLayout = n => {
    let clearSettingObject = {}
    if (n == 0) {
      clearSettingObject = {
        ...themeSettings,
        backgroundColor: { r: 255, g: 255, b: 255, a: 1 },
        bodyBackgroundImage: '',
        cardBackgroundColor: { r: 255, g: 255, b: 255, a: 0 },
        fontColor: { r: 0, g: 0, b: 0, a: 1 },
        cardAlignment: 'top',
        stretch: 2,
      }
    }
    setThemeSettings({ ...themeSettings, ...clearSettingObject, layout: n })
  }
  return (
    <>
      <form
        className={`${classes.content} ${!isUserPremium && classes.locked}`}
      >
        {page == 'settings' && (
          <>
            <div className={classes.presets}>
              {themePresets.map((value, index) => {
                const backgroundImage =
                  value.theme.bodyBackgroundImage &&
                  value.theme.bodyBackgroundImage != ''
                    ? colors[value.name]
                      ? value.colors[colors[value.name]].bodyBackgroundImage
                        ? value.colors[colors[value.name]].bodyBackgroundImage
                        : `${URL.CDN}assets/theme/${value.name}/${
                            colors[value.name]
                          }.svg` || ''
                      : `${URL.CDN}assets/theme/${value.name}/${value.theme.bodyBackgroundImage}`
                    : ''

                return (
                  <Card className={classes.cardRoot}>
                    <CardActionArea
                      onClick={() => {
                        setThemeSettings({
                          ...value.theme,
                          bodyBackgroundImage: backgroundImage,
                          ...value.colors[
                            colors[value.name] || value.defaultColor
                          ],
                        })
                        setPage('preset-settings')
                      }}
                    >
                      {backgroundImage != '' ? (
                        <CardMedia
                          className={classes.media}
                          image={backgroundImage}
                          title=""
                        >
                          <h3
                            className={classes.previewText}
                            style={{
                              color: rgbaParser(
                                colors[value.name]
                                  ? value.colors[colors[value.name]].fontColor
                                  : value.colors[value.defaultColor].fontColor,
                              ),
                            }}
                          >
                            {value.previewText || ''}
                          </h3>
                        </CardMedia>
                      ) : (
                        <CardMedia className={classes.media} title="">
                          <div
                            style={{
                              position: 'absolute',
                              width: '100%',
                              height: '100%',
                              backgroundColor: rgbaParser(
                                colors[value.name]
                                  ? value.colors[colors[value.name]]
                                      .backgroundColor
                                  : value.colors[value.defaultColor]
                                      .backgroundColor,
                              ),
                            }}
                          ></div>
                          <h3
                            className={classes.previewText}
                            style={{
                              color: rgbaParser(
                                colors[value.name]
                                  ? value.colors[colors[value.name]].fontColor
                                  : value.colors[value.defaultColor].fontColor,
                              ),
                            }}
                          >
                            {value.previewText || ''}
                          </h3>
                        </CardMedia>
                      )}
                    </CardActionArea>
                    <CardActions className={classes.cardActions}>
                      <div className={classes.colours}>
                        {Object.keys(value.colors).map((colorValue, index) => {
                          return (
                            <div
                              key={index}
                              className={classes.colorButton}
                              style={{ backgroundColor: colorValue }}
                              onClick={() => {
                                setColors({
                                  ...colors,
                                  [value.name]: colorValue,
                                })
                              }}
                            ></div>
                          )
                        })}
                      </div>
                      <div>
                        <Tooltip title="Preview Sample" placement="top">
                          <CoreIconButton
                            size="small"
                            color="dark"
                            variant="text"
                            onClick={() => {
                              window.open(
                                colors[value.name]
                                  ? value.colors[colors[value.name]].sampleUrl
                                  : value.colors[value.defaultColor].sampleUrl,
                                '_blank',
                                'noopener,noreferrer',
                              )
                            }}
                          >
                            <Icon icon="mdi:eye" />{' '}
                          </CoreIconButton>
                        </Tooltip>
                      </div>
                    </CardActions>
                  </Card>
                )
              })}
            </div>
          </>
        )}
        {page == 'preset-settings' && (
          <div className={classes.contentList}>
            <div className={classes.editPresetHeader}>
              <Icon icon="heroicons:adjustments-horizontal" fontSize="20px" />
              <Typography
                fontSize={'15px'}
                fontWeight={500}
                fontFamily={'Inter'}
              >
                Preset settings
              </Typography>
              <div
                style={{
                  flexGrow: 1,
                }}
              ></div>
              <CoreButton
                variant="outlined"
                size="small"
                color="secondary"
                onClick={() => {
                  setPage('settings')
                  track('edit_preset_settings')
                }}
              >
                Discover presets
              </CoreButton>
            </div>
            <Typography fontSize="15px" fontWeight={500}>
              Font Settings
            </Typography>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
              }}
            >
              <Typography fontSize="12px" fontWeight={500} fontFamily="Inter">
                Typography
              </Typography>
              <FontSelect
                value={themeSettings?.font || 'Inter'}
                onChange={font =>
                  setThemeSettings({
                    ...themeSettings,
                    font,
                  })
                }
              />
            </div>
            <div className={classes.inputItem}>
              <Autocomplete
                disablePortal
                disableClearable
                disabled={!pageReady}
                options={availableSizes}
                value={availableSizes.find(s => s.label === themeSettings?.fontSize) || availableSizes[2]}
                getOptionLabel={option => option?.label ?? ''}
                isOptionEqualToValue={(option, val) => option.label === val.label}
                onChange={(e, values) => {
                  setThemeSettings({
                    ...themeSettings,
                    fontSize: values.label,
                  })
                }}
                fullWidth
                renderInput={params => (
                  <CoreTextField {...params} label="Size" size="small" />
                )}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 10,
                  width: '50%',
                }}
              >
                <Typography
                  fontFamily={'Inter'}
                  fontSize="14px"
                  fontWeight={400}
                >
                  Font Color
                </Typography>
                <div className={classes.pickerBg}>
                  <span
                    className={classes.pickerSpan}
                    style={{
                      backgroundColor: rgbaParser(themeSettings?.fontColor),
                    }}
                    onClick={event => {
                      setPickerVisibles({
                        ...pickerVisibles,
                        fontColor: !pickerVisibles.fontColor,
                      })
                      setAnchorEl(event.currentTarget)
                    }}
                  ></span>
                  <Popover
                    id={pickerVisibles.fontColor ? 'fontColor' : undefined}
                    open={pickerVisibles.fontColor}
                    anchorEl={anchorEl}
                    onClose={() => {
                      setPickerVisibles({ ...pickerVisibles, fontColor: false })
                      setAnchorEl(null)
                    }}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                  >
                    <ChromePicker
                      disabled={!pageReady}
                      color={themeSettings?.fontColor || '#000000'}
                      onChange={value => {
                        setThemeSettings({
                          ...themeSettings,
                          fontColor: value.rgb,
                        })
                      }}
                    />
                  </Popover>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 10,
                  width: '50%',
                }}
              >
                <Typography
                  fontFamily={'Inter'}
                  fontSize="14px"
                  fontWeight={400}
                >
                  Button Color
                </Typography>
                <div className={classes.pickerBg}>
                  <span
                    className={classes.pickerSpan}
                    style={{
                      backgroundColor:
                        rgbaParser(themeSettings?.buttonColor) || '#ffffff',
                    }}
                    onClick={event => {
                      setPickerVisibles({
                        ...pickerVisibles,
                        buttonColor: !pickerVisibles.buttonColor,
                      })
                      setAnchorEl(event.currentTarget)
                    }}
                  ></span>

                  <Popover
                    id={pickerVisibles.buttonColor ? 'buttonColor' : undefined}
                    open={pickerVisibles.buttonColor}
                    anchorEl={anchorEl}
                    onClose={() => {
                      setPickerVisibles({
                        ...pickerVisibles,
                        buttonColor: false,
                      })
                      setAnchorEl(null)
                    }}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                  >
                    <ChromePicker
                      disabled={!pageReady}
                      color={themeSettings?.buttonColor || '#000000'}
                      onChange={value =>
                        setThemeSettings({
                          ...themeSettings,
                          buttonColor: value.rgb,
                        })
                      }
                    />
                  </Popover>
                </div>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
              }}
            >
              <Typography fontSize="15px" fontWeight={500} fontFamily={'Inter'}>
                Page layout
              </Typography>
              <SettingLayout
                classes={classes}
                themeLayout={themeSettings?.layout}
                onChangeLayout={n => handleLayout(n)}
              />
            </div>
            <div
              style={{
                opacity: themeSettings?.layout == 0 ? 0 : 1,
                transition: '.3s linear all ',
                height: themeSettings?.layout == 0 ? 0 : 'auto',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                marginBottom: 60,
                overflowY: themeSettings?.layout == 0 ? 'hidden' : 'auto',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8,
                    width: '50%',
                  }}
                >
                  <Typography
                    fontFamily={'Inter'}
                    fontSize="14px"
                    fontWeight={400}
                  >
                    Background color
                  </Typography>
                  <div className={classes.pickerBg}>
                    <span
                      className={classes.pickerSpan}
                      style={{
                        backgroundColor:
                          rgbaParser(themeSettings?.backgroundColor) ||
                          '#ffffff',
                      }}
                      onClick={event => {
                        setPickerVisibles({
                          ...pickerVisibles,
                          backgroundColor: !pickerVisibles.backgroundColor,
                        })
                        setAnchorEl(event.currentTarget)
                      }}
                    ></span>

                    <Popover
                      id={
                        pickerVisibles.backgroundColor
                          ? 'backgroundColor'
                          : undefined
                      }
                      open={pickerVisibles.backgroundColor}
                      anchorEl={anchorEl}
                      onClose={() => {
                        setPickerVisibles({
                          ...pickerVisibles,
                          backgroundColor: false,
                        })
                        setAnchorEl(null)
                      }}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                    >
                      <ChromePicker
                        disabled={!pageReady}
                        color={themeSettings?.backgroundColor || '#ffffff'}
                        onChange={value =>
                          setThemeSettings({
                            ...themeSettings,
                            backgroundColor: value.rgb,
                          })
                        }
                      />
                    </Popover>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8,
                    width: '50%',
                  }}
                >
                  <Typography
                    fontFamily={'Inter'}
                    fontSize="14px"
                    fontWeight={400}
                  >
                    Page background color
                  </Typography>
                  <div className={classes.pickerBg}>
                    <span
                      className={classes.pickerSpan}
                      style={{
                        backgroundColor:
                          rgbaParser(themeSettings?.cardBackgroundColor) ||
                          '#ffffff',
                      }}
                      onClick={event => {
                        setPickerVisibles({
                          ...pickerVisibles,
                          cardBackgroundColor: !pickerVisibles.cardBackgroundColor,
                        })
                        setAnchorEl(event.currentTarget)
                      }}
                    ></span>

                    <Popover
                      id={
                        pickerVisibles.cardBackgroundColor
                          ? 'cardBackgroundColor'
                          : undefined
                      }
                      open={pickerVisibles.cardBackgroundColor}
                      anchorEl={anchorEl}
                      onClose={() => {
                        setPickerVisibles({
                          ...pickerVisibles,
                          cardBackgroundColor: false,
                        })
                        setAnchorEl(null)
                      }}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                    >
                      <ChromePicker
                        disabled={!pageReady}
                        color={themeSettings?.cardBackgroundColor || '#ffffff'}
                        onChange={value =>
                          setThemeSettings({
                            ...themeSettings,
                            cardBackgroundColor: value.rgb,
                          })
                        }
                      />
                    </Popover>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 4,
                }}
              >
                <Typography
                  fontFamily={'Inter'}
                  fontSize="14px"
                  fontWeight={400}
                >
                  Background Image
                </Typography>
                {themeSettings?.bodyBackgroundImage &&
                themeSettings?.bodyBackgroundImage != '' ? (
                  <>
                    <div className={classes.bgContainer}>
                      <img
                        className={classes.backgroundImage}
                        src={themeSettings?.bodyBackgroundImage}
                        alt=""
                      />
                      <div
                        className={classes.bgTrash}
                        onClick={() => {
                          setThemeSettings({
                            ...themeSettings,
                            bodyBackgroundImage: '',
                          })
                        }}
                      >
                        <CoreIconButton
                          disabled={!pageReady}
                          variant="text"
                          size="small"
                          color="secondary"
                        >
                          <Icon icon="bx:trash-alt" />
                        </CoreIconButton>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <CoreTextField
                      type="file"
                      fullWidth={true}
                      disabled={!pageReady}
                      marginTop={false}
                      onChange={onUploadBackgroundImage}
                    />
                  </>
                )}
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 4,
                }}
              >
                <Typography
                  fontFamily={'Inter'}
                  fontSize="14px"
                  fontWeight={400}
                >
                  Page Vertical Alignment
                </Typography>
                <SettingDirection
                  classes={classes}
                  cardAlignment={themeSettings?.cardAlignment}
                  onChangeCardAlignment={state =>
                    setThemeSettings({
                      ...themeSettings,
                      cardAlignment: state,
                    })
                  }
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 4,
                }}
              >
                <Typography
                  fontFamily={'Inter'}
                  fontSize="14px"
                  fontWeight={400}
                >
                  Page Stretch
                </Typography>
                <SettingStretch
                  themeStretch={themeSettings?.stretch}
                  onToggleStretch={state => {
                    let newStretch = themeSettings?.stretch - 1
                    if (newStretch <= 0) newStretch = 3
                    setThemeSettings({
                      ...themeSettings,
                      stretch: newStretch,
                    })
                  }}
                />
              </div>
            </div>
            {!pageReady ? (
              <div className={classes.bottomButton}>
                <CircularProgress></CircularProgress>
              </div>
            ) : (
              <div className={classes.bottomButton} style={{ gap: 5 }}>
                <CoreButton
                  fullWidth={true}
                  disabled={!pageReady}
                  color="success"
                  size="small"
                  variant="contained"
                  onClick={saveSettings}
                >
                  {pageReady ? 'Apply Your Theme' : 'Saving...'}
                </CoreButton>
              </div>
            )}
          </div>
        )}
      </form>
      {!isUserPremium && (
        <>
          <div className={classes.premiumContainer}>
            <img src="/assets/premium.gif" alt="premium" width="128" />
            <Alert severity="warning">
              You can customize with Premium Plan.
            </Alert>
            <CoreButton
              variant="contained"
              style={{ marginTop: '1rem' }}
              onClick={handleOpenPremiumDetails}
            >
              Upgrade your Plan
            </CoreButton>
          </div>
        </>
      )}
    </>
  )
}

export default withStyles(styles)(ThemeSettings)
